import React, { useState, useEffect } from 'react';
import axios from 'axios'; 
import BillingDetails from './components/BillingDetails';
import OrderSummary from './components/OrderSummary';
import useForm from './hooks/useForm';
import './PayNow.css';
import TriptaLogo from '../../../assets/TriptaLogo.webp';
import Data from '../../../product_data.json';


const PayNow = () => {
  const { formData, handleChange, handleSubmit } = useForm({
    name: '',
    email: '',
    mobile: '',
    HID: '',
    gstin: '',
    pinCode: '',
    address: '',
  });

  const [summary, setSummary] = useState({
    subtotal: Data.Subtotal,
    discount: Data.Discount,
    FeaturePack: Data.FeaturePack,
    Node: 0,
    NoOfNode: Data.NoOfNode,
    gst: 0,
    total: 0,
  });

  useEffect(() => {
    const Node = ((summary.NoOfNode -1)*6000);
    const gst = (summary.subtotal +summary.FeaturePack + (summary.NoOfNode * summary.Node)- summary.discount)* 0.18;
    const total = summary.subtotal + summary.FeaturePack + gst - summary.discount;
    setSummary((prevSummary) => ({
      ...prevSummary,
      Node,
      gst,
      total,
    }));
  }, [summary.subtotal, summary.discount]);

  const handleFormSubmit = async () => {
    
    try {
      const response = await axios.post('/sendEmail', { formData });
      console.log('Email sent successfully:', response.data);
      // Optionally handle success message or redirect
    } catch (error) {
      console.log('Error sending email:', error);
      // Handle error state or display error message
    }
  };

  return (
    <div className="paynow-container">
      <header>
        <img src={TriptaLogo} alt="Tripta Logo" className="logo" />
        <h1 className='order-summary-title'>Online Purchase</h1>
      </header>
      <div className="content">
        <div className="form-section">
          <BillingDetails formData={formData} handleChange={handleChange} handleSubmit={handleSubmit(handleFormSubmit)} />
        </div>
        <div className="summary-section">
          <OrderSummary summary={summary} />
        </div>
      </div>
    </div>
  );
};

export default PayNow;
